import { useShowSnackbar } from "@octopusdeploy/design-system-components";
import type { ControlType, ProcessTemplateParameterResource, TemplateParameterResource } from "@octopusdeploy/octopus-server-client";
import { bindParameterName } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import TemplateParameterEditorDialog from "~/areas/platformHub/processTemplates/TemplateParameterEditorDialog";
import { useProducerTemplateProcessContext } from "~/areas/projects/components/Process/ProjectTemplates/useProducerTemplateProcessContext";
import { IconButtonWithTooltip } from "~/components/IconButtonWithTooltip";
import { BaseParameterSelector } from "~/components/ParameterSelector/BaseParameterSelector";
interface ProducerTemplatesParameterSelectorProps {
    selectedParameter: string | null | undefined;
    onParameterChange(value: string | null): void;
    controlType: ControlType;
    allowClear: boolean;
    error?: string | undefined;
    label?: string;
    bindValue?: boolean;
    onParameterAdded?: (parameters: TemplateParameterResource[]) => void;
}
export function ProducerTemplatesParameterSelector({ allowClear, controlType, error, label, onParameterChange, selectedParameter, bindValue = true, onParameterAdded }: ProducerTemplatesParameterSelectorProps) {
    const templateContext = useProducerTemplateProcessContext();
    const parameters = templateContext?.parameters;
    const [showParameterDialog, setShowParameterDialog] = React.useState(false);
    const showSnackbar = useShowSnackbar();
    const handleParameterCreated = (newParameter: ProcessTemplateParameterResource) => {
        const updatedParameters = [...(parameters || []), newParameter];
        onParameterAdded?.(updatedParameters);
        // Select the newly created parameter
        const newValue = bindValue ? bindParameterName(newParameter.Name) : newParameter.Name;
        onParameterChange(newValue);
        showSnackbar("Parameter successfully created. Manage in the Parameters tab.");
        setShowParameterDialog(false);
    };
    const actions = onParameterAdded
        ? [
            <IconButtonWithTooltip toolTipContent="Add" onClick={() => {
                    setShowParameterDialog(true);
                }} icon="PlusIcon" accessibleName="Add"/>,
        ]
        : [];
    return (<>
            <BaseParameterSelector selectedParameter={selectedParameter} onParameterChange={onParameterChange} controlType={controlType} allowClear={allowClear} error={error} label={label} parameters={parameters} bindValue={bindValue} actions={actions}/>
            <TemplateParameterEditorDialog allParameters={parameters || []} onOk={handleParameterCreated} processTemplateLink={undefined} emptyParameterDefaults={{
            DisplaySettings: { "Octopus.ControlType": controlType },
        }} disableControlType={true} open={showParameterDialog} close={() => setShowParameterDialog(false)}/>
        </>);
}
